import { Collapse } from '@mui/material';
import { RiCloseLine, RiPriceTag3Fill } from '@remixicon/react';
import { AgButton, AgText } from 'src/components/ui';
import Hint from '../../components/atoms/Hint';

export type LabelProps = {
  label: string;
  color: string;
  description?: string;
  onRemove?: () => void;
  collapseRemoveButton?: boolean;
};

export default function Label({ label, color, description, onRemove, collapseRemoveButton = true }: LabelProps) {
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <Hint title={description}>
      <div className="mx-2" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
        <div className="center bg-white gap-1 rounded-md h-6 px-1 border border-neutral-5">
          <RiPriceTag3Fill size="16" color={color} />
          <AgText size="14" className="whitespace-nowrap">
            {label}
          </AgText>
          {onRemove && (
            <Collapse in={isHovered || !collapseRemoveButton} orientation="horizontal" className="mt-1">
              <AgButton
                variant="ghost"
                size="icon-xs"
                shape="circle"
                className="h-[18px] w-[18px] p-0"
                onPress={() => onRemove()}
              >
                <RiCloseLine size={16} className="text-neutral-7" />
              </AgButton>
            </Collapse>
          )}
        </div>
      </div>
    </Hint>
  );
}
